import app from "./../../../main";
export default {
  /////////////
  // CORE STATE
  /////////////
  SET_LANG (state, payload) {
    app.$i18n.locale = payload
  }
};
